import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MultiStepService } from "../../services/multi-step.service";

enum FIELD_TYPE_CODE {
    TEXT = "TEXT",
    NUMBER = "NUMBER",
    TEXTAREA = "TEXTAREA",
    DATE = "DATE",
    DATETIME = "DATETIME",
    SELECTLIST_SINGLE = "SELECTLIST_SINGLE",
    SPACE = "SPACE",
    MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
    RADIO_BUTTON = "RADIO_BUTTON",
    TITLE = "TITLE",
    LABEL = "LABEL",
    CHECK_BOX = "CHECK_BOX",
    NUMBER_CURRENCY = "NUMBER_CURRENCY",
    TEXT_CHECK_BOX = "TEXT_CHECK_BOX",
    DATE_CHECK_BOX = "DATE_CHECK_BOX",
    TABLE = "TABLE",
    TABLE_COMPLEX = "TABLE_COMPLEX",
    UPLOAD_FILE = "UPLOAD_FILE"
}

@Component({
    selector: 'app-component-multi-step',
    templateUrl: './multi-step.component.html',
    styleUrls: ['./multi-step.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiStepComponent implements OnInit, AfterContentChecked {
    isMobile = window.innerWidth < 1000 ? true : false;
    title: string;
    stepNum: number;
    currentStep: number;
    steps: number[] = [];
    listControl = [];
    listStepControl = [];
    isLoading = false;
    code: string;
    version: string;

    constructor(
        private multiStepService: MultiStepService,
        private activeRoute: ActivatedRoute,
        private cdref: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.currentStep = 0;
        this.activeRoute.queryParams.subscribe(
            res => {
                this.code = res['code'];
                this.getFormByCode();
            }
        )
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    getListFieldOptions() {
        this.multiStepService.getListFieldOptions({ formCode: this.code }).subscribe(
            res => {

            },
            error => {
                console.log(error);
            },
            () => {

            }
        )
    }

    getFieldCreateForm() {
        this.multiStepService.getFieldCreateForm({
            formCode: this.code,
            enviroment: 2,
            version: this.version
        }).subscribe(
            res => {
                console.log(res);

                if (res.result.isSuccess) {
                    this.listControl = res.result.value.result;
                    this.generateForm();
                }
            },
            error => {
                console.log(error);
            },
            () => {

            }
        )
    }

    getFormByCode() {
        this.multiStepService.getFormByCode({ formCode: this.code }).subscribe(
            res => {
                if (res.result.isSuccess) {
                    let result = res.result.value.result;
                    this.title = result.name;
                    this.stepNum = result.stepMobile;
                    this.version = result.versionActive;

                    for (let i = 1; i <= this.stepNum; i++) {
                        this.steps.push(i);
                    }

                    this.getFieldCreateForm();
                }

                console.log(res);
            },
            error => {
                console.log(error);
            },
            () => {

            }
        )
    }

    generateControl(fieldTypeCode: string) {

    }

    generateForm() {
        this.listStepControl = this.listControl.filter(x => x.step == this.currentStep + 1);
        console.log(this.listStepControl);
    }

    pre() {
        this.currentStep -= 1;
        this.generateForm();
    }

    next() {
        this.currentStep += 1;
        this.generateForm();
    }

    done() {
        alert('Submit Form');
    }
}